// src/config/app.config.ts
export const APP_CONFIG = {
  name: "LRNSY",
  version: "1.0.0",
  loading: {
    minDisplayTime: 2000,
    progressIncrementInterval: 120,
    messages: [
      "Preparing something unforgettable…",
      "Arranging a beautiful surprise…",
      "Someone is about to smile…",
      "Holding a moment just for you…",
    ],
  },
  particles: {
    default: 20,
    routes: [
      { path: "/", quantity: 30, exact: true },
      { path: "/create", quantity: 1 },
      { path: "/preview", quantity: 5 },
      { path: "/recipient", quantity: 10 },
    ] as const,
  },
  cache: {
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  },
  routes: {
    public: ["/", "/signin", "/archetypes", "/recipient"],
    protected: [
      "/home",
      "/detail",
      "/create",
      "/preview",
      "/payment",
      "/share",
      "/dashboard",
    ],
  } as const,
} as const;
